
export const yearMessage = "We’re sorry. We cannot currently provide Quotes online for vehicles that are 20 years or older. Please call our broker partner at 1-0000000000 to get a quote over the phone.";

export const eachDayKilometresRange = [1, 2, 5, 7, 10, 15, 20, 30, 40, 50, 60, 70, 80, 90, 100, 150, 200];
export const eachDayKilometresRangeForBusiness = [0, 2, 5, 7, 10, 15, 20, 30, 40, 50, 60, 70, 80, 90, 100, 150, 200, 250, 300, 350, 400];
export const eachYearKilometresRange = [500, 1000, 2000, 3000, 5000, 8000, 10000, 15000, 20000, 30000, 50000, 60000, 80000, 100000];
